import { render, staticRenderFns } from "./teacher_type.vue?vue&type=template&id=72ab4545"
import script from "./teacher_type.vue?vue&type=script&lang=js"
export * from "./teacher_type.vue?vue&type=script&lang=js"
import style0 from "./teacher_type.vue?vue&type=style&index=0&id=72ab4545&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports